<template>
  <main class="main main--full-height">
    <div class="group">
      <div class="grid grid--auth">
        <div class="grid__item grid__item--4 hide-below-medium" />
        <div class="grid__item grid__item--2 posr">
          <h1 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="h1 group__title mw600 mb0">{{ title }}</h1>
          <p class="p group__desc mb2">
            <span v-html="description" />
            <span 
              v-if="step === `password`"
            ><button
              v-if="step === `password`"
              @click="onRetry"
              class="link auth__reset c-accent "
            >
              Retry Verification
            </button></span
            >
          </p>

          <ui-auth
            v-if="step === `email`"
            key="reset"
            id="reset"
            :success="onEmailSuccess"
          />

          <template v-if="step === `otp`">
            <p class="medium">
              <button @click="resendVerification" class="link auth__reset">
                {{
                  resendValidationLoading ? `Sending email…` : `Resend email`
                }}
              </button>
            </p>

            <ui-auth id="verify" :success="onOtpSuccess" :fail="onOtpFail" />
          </template>

          <ui-auth
            v-if="step === `password`"
            key="resetPassword"
            id="resetPassword"
            :success="onPasswordSetSuccess"
            :fail="onPasswordSetFail"
          />
          <p class="mt2 small" v-if="step === `password`">
            If your email hasn't arrived, please check your spam folder or try
            again.
            <button @click="onRetry" class="link auth__reset">
              {{ resendValidationLoading ? `Sending email…` : `Resend email` }}
            </button>
          </p>
          <p
            v-show="resendErrorMessage"
            v-for="(msg, index) in resendErrorMessage"
            :key="index"
            class="c-error mt"
          >
            {{ msg.message }}
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Ui
import UiAuth from 'components/Auth';

// Modules
import ModuleDots from 'components/Dots';

// Export
export default {
  name: 'view-reset',

  // Components
  components: {
    UiAuth,
    ModuleDots,
  },

  // Data
  data() {
    return {
      step: 'email',
      resendValidationLoading: false,
      email: '',
      resendErrorMessage: null,
    };
  },

  // Computed
  computed: {
    ...mapGetters('forms', ['getFormView', 'getFieldModel']),
    ...mapGetters('auth', ['loadingPasswordReset', 'tempEmail']),
    ...mapGetters('app', ['org']),

    
    title() {
      return (
        {
          email: 'Enter Your Email Address',
          otp: 'Email Verification Required',
          password: 'Create Your New Password',
        }[this.step] || ''
      );
    },

    description() {
      const descriptions = {
        email:
          'We’ll need to send a verification code to the email you created your account with.',
        password: `We’ve sent a verification code to <span class="fw-bold">${this.email}</span>. Please enter this below to verify your account.`,
      };

      return descriptions[this.step] || descriptions.email;
    },
  },

  // Watchers
  watch: {
    loadingPasswordReset() {
      localStorage.setItem('resetCheck', true);
      this.$router.push({ name: 'login' });
      this.$store.commit('auth/SAVE_EMAIL_TO_STATE', ''); // Reset state email
    },
  },

  // Methods
  methods: {
    ...mapActions('forms', [
      'setFormState',
      'updateField',
      'destroyForm',
      'setupForm',
    ]),
    ...mapActions('auth', [
      'requestResendVerification',
      'requestResetPassword',
    ]),

    setStep(step) {
      const messages = [];

      if (step === 'otp') {
        messages.push(
          'You need to verify your email address before you can set your new password'
        );
      } else if (step === 'email') {
        messages.push('Please re-enter your email address and try again');
      } else {
        const fromOtp = this.step === 'otp';
        messages.push(
          `${
            fromOtp ? 'Thanks for verifying your email address. ' : ''
          }You will need to enter ${
            fromOtp ? 'another' : 'a'
          } 6-digit code in order to set your new password`
        );
      }

      this.$store.dispatch('app/openLoader', {
        messages,
      });

      setTimeout(() => {
        this.step = step;
      }, 300); // TODO: Var
    },

    onEmailSuccess({ status }) {
      sessionStorage.setItem(
        'auth-reset|email',
        this.getFieldModel('auth-reset|email')
      );
      this.email = sessionStorage.getItem('auth-reset|email');
      if (status === 200) this.setStep('password');
      // TODO: Handle status !== 200
    },

    onRetry() {
      this.setStep('email');
    },

    onEmailFail() {
      // TODO: Ensure that this is the only reason that it fails, and if not direct users accordingly
      this.setStep(
        'otp',
        'You need to verify your email address before you can set your new password'
      );
    },

    onOtpSuccess() {
      this.setStep('password');
      this.requestResetPassword({ email: this.tempEmail });
    },

    onOtpFail(error) {
      // TODO: Handle error
      console.error('Something went wrong', error);
    },

    onPasswordSetSuccess() {
      sessionStorage.removeItem('auth-reset|email');
    },

    onPasswordSetFail(error) {
      // TODO: Handle error
      console.error('Something went wrong', error);
    },

    resendVerification() {
      this.resendValidationLoading = true;

      this.requestResendVerification({
        email: this.tempEmail,
      })
        .then(response => {
          setTimeout(() => {
            this.resendValidationLoading = false;
          }, 3000);

          return response;
        })
        .catch(error => {
          console.error(error);

          console.log(error);

          this.resendErrorMessage =
            error.data.errors.length > 0 && error.data.errors;

          setTimeout(() => {
            this.resendValidationLoading = false;
          }, 3000);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Reset.vue?401893f9